'use strict'

const state = {
    warnings: [{}]
}

const getters = {
    getStoreWarning(state) {
        return state.warnings
    }
}

const actions = {
    setWarning({commit}, data){ 
        commit('SET_WARNING', data)
    },
}

const mutations = {
    SET_WARNING(state, data) {
        state.warnings = data.map((w, index) => {
            w.position = index
            return w
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
